import React, { useState, useEffect } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Tab, Nav, Collapse, Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { IMAGES } from "../../constant/theme";
import {
  cancelPaymentTransaction,
  getPaymentDetailsById,
  getPlayers,
  getPlayerSubscription,
  PaidPlayerPackageChange,
  paymentStatusById,
} from "../../../services/academicService";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import PlayerReciptHistoryModal from "../../components/PlayerReciptHistoryModal";

function PlayerProfile({ player = {} }) {
  const [paymentStatus, setPaymentStatus] = useState(player?.paymentStatus);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    setPaymentStatus(player?.paymentStatus || "Unpaid");
  }, [player]);

  const handlePaymentChange = async (e) => {
    const newStatus = e.target.value;

    // If player is already paid — do not allow change
    if (player.paymentStatus === "Paid") {
      toast.info("Already paid — no update required");
      return; // IMPORTANT: Do not update state
    }

    // If user selects Unpaid again -> do nothing
    if (newStatus === "Unpaid") {
      setPaymentStatus("Unpaid");
      return;
    }

    // Update only when changing from Unpaid → Paid
    if (newStatus === "Paid") {
      setPaymentStatus("Paid");
      setIsUpdating(true);

      try {
        const resp = await paymentStatusById(player.id);

        if (resp) {
          toast.success("Payment status updated successfully");
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to update payment status");
      } finally {
        setIsUpdating(false);
      }
    }
  };

  // const handlePaymentChange = (e) => {
  //   setPaymentStatus(e.target.value);
  // };

  console.log("outputtttttttt", player);
  const personalDetail = [
    { title: "Name", subtitle: player?.name || "-" },
    { title: "Date of Birth", subtitle: player?.dob || "-" },
    { title: "Age", subtitle: player?.age || "-" },
    { title: "Gender", subtitle: player?.sex || "-" },
    {
      title: "Package",
      subtitle: player?.subscription?.packageType?.name || "-",
    },
    { title: "Address", subtitle: player?.address || "-" },
    { title: "Mobile Number", subtitle: player?.phone || "-" },
    { title: "Batting", subtitle: player?.batting || "-" },
    { title: "Bowling", subtitle: player?.bowling || "-" },
    {
      title: "Wicket Keeping",
      subtitle: player?.wicketKeeper ? "Yes" : "No" || "-",
    },
    {
      title: "Other Club Member",
      subtitle: player?.memberOfOtherClub ? "Yes" : "No" || "-",
    },
    { title: "Parent Name", subtitle: player?.parentName || "-" },
    { title: "Total Paid Amount", subtitle: player?.amountDeposited || "-" },
    { title: "Due Amount", subtitle: player?.dueAmount || "-" },
    { title: "Renewal Date", subtitle: player?.dueDate || "-" },
    { title: "Payemnt Status", subtitle: player?.paymentStatus || "-" },
    // { title: "Receipt No", subtitle: player?.receiptNumber || "-" },
    {
      title: "Next Dues Date",
      subtitle: player?.playerSubscription?.nextDueDate || "-",
    },
    { title: "Date of Joining", subtitle: player?.dateOfJoining || "-" },
  ];

  async function updatePayment() {
    try {
      const response = await paymentStatusById(player?.id);
      if (response) {
        toast.success("Payment status updated successfully", {
          position: "top-right",
          autoClose: 1000,
        });
      }
    } catch (error) {
      console.error("Error updating payment status:", error);
    }
  }

  return (
    <div className="row">
      <div className="col-xl-9 col-xxl-8 col-lg-8">
        <div className="card overflow-hidden">
          <div
            className="text-center p-3 overlay-box"
            style={{ backgroundImage: `url(${IMAGES.BigImg1})` }}
          >
            <h3 className="mt-3 mb-1 text-white">{player?.name || "Player"}</h3>
          </div>

          <div className="row">
            {personalDetail.map((item, idx) => (
              <div
                key={idx}
                className="list-group-item d-flex justify-content-between col-md-6 col-6"
              >
                <span>{item.title}</span>
                <strong className="text-muted">{item.subtitle}</strong>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="col-xl-3 col-xxl-4 col-lg-4">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="profile-tab">
                  <div className="custom-tab-1">
                    <Tab.Container defaultActiveKey={"Posts"}>
                      <Nav as="ul" className="nav nav-tabs">
                        <Nav.Item as="li">
                          <Nav.Link eventKey="Posts">Fee Status</Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content className="tab-content">
                        <Tab.Pane eventKey={"Posts"}>
                          <div className="profile-about-me">
                            <div className="pt-4 border-bottom-1 pb-4">
                              <h4 className="text-primary mb-4">
                                Payment Information
                              </h4>
                              <div className="row mb-3">
                                <div className="col-sm-6">
                                  <h6>Payment Status:</h6>
                                  <select
                                    className="form-select"
                                    value={paymentStatus}
                                    disabled
                                  // onChange={handlePaymentChange}
                                  >
                                    <option value="Unpaid">Unpaid</option>
                                    <option value="Paid">Paid</option>
                                    <option value="Partial">Partial</option>
                                  </select>
                                </div>
                                <div className="col-sm-6 mt-4">
                                  <span
                                    className={`badge ${paymentStatus === "Paid"
                                      ? "badge-success"
                                      : "badge-danger"
                                      }`}
                                  >
                                    {paymentStatus}
                                  </span>
                                </div>
                              </div>
                              <p>
                                By default, the status is set to{" "}
                                <strong>Unpaid</strong>. You can update it once
                                payment is received.
                              </p>
                            </div>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const AboutPlayer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open2, setOpen2] = useState(true);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [player, setPlayer] = useState(location.state?.user || {});
  const [reciptModal, setReciptModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [packageModal, setPackageModal] = useState(false);
  const [packageOptions, setPackageOptions] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [changingPackage, setChangingPackage] = useState(false);
  const [loadingPackages, setLoadingPackages] = useState(false);

  const downloadExcel = async (playerId) => {
    try {
      const res = await getPaymentDetailsById(playerId);

      const paymentDetails = res?.map((data, index) => ({
        "S.No": index + 1,
        Package: data?.player?.subscription?.packageType?.name,
        "Paid Amount": data?.amount,
        "Receipt No.": data?.receiptNumber,
        "Payment Date": data?.paymentDate
          ? new Date(data?.paymentDate).toLocaleString()
          : "",
        "Payment Mode": data?.paymentType,
        Description: data?.description,
      }));

      const worksheet = XLSX.utils.json_to_sheet(paymentDetails);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Members");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, "payment_history.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };

  useEffect(() => {
    fetchPaymentDetails();
  }, []);

  const fetchPaymentDetails = async () => {
    try {
      const res = await getPaymentDetailsById(player?.id);
      if (res) {
        setPaymentDetails(res);
      }
    } catch (error) {
      console.error("Error fetching payment details:", error);
    }
  };

  // location.state is only a snapshot, so re-read the player from the list API
  const refreshPlayer = async () => {
    try {
      const res = await getPlayers(0, 1, player?.phone || player?.name);
      const latest = (res?.content || res)?.find?.((p) => p.id === player?.id);
      if (latest) {
        setPlayer(latest);
      }
    } catch (error) {
      console.error("Error refreshing player:", error);
    }
  };

  const handleCancelTransaction = async (historyItem) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to cancel this transaction?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No",
    });

    if (result.isConfirmed) {
      try {
        const payload = {
          historyId: historyItem?.id
        }
        await cancelPaymentTransaction(payload);
        setPaymentDetails((prev) =>
          prev.filter((item) => item?.id !== historyItem?.id)
        );
        toast.success("Transaction cancelled successfully");
        fetchPaymentDetails();
        refreshPlayer();
      } catch (error) {
        console.error("Error cancelling transaction:", error);
        toast.error(
          error?.response?.data?.message || "Failed to cancel transaction"
        );
      }
    }
  };

  useEffect(() => {
    refreshPlayer();
  }, []);

  const openPackageModal = async () => {
    if (loadingPackages) return;

    setLoadingPackages(true);
    try {
      const res = await getPlayerSubscription();
      const options = (res?.content || res || []).map((item) => ({
        value: item.id,
        label: item?.packageType?.name || item?.name,
      }));
      setPackageOptions(options);
      setSelectedPackage(
        options.find((o) => o.value === player?.subscription?.id) || null,
      );
      setPackageModal(true);
    } catch (error) {
      console.error("Error loading packages:", error);
      toast.error("Failed to load packages");
    } finally {
      setLoadingPackages(false);
    }
  };

  const handlePackageChange = async () => {
    if (!selectedPackage) {
      toast.error("Please select package");
      return;
    }

    setChangingPackage(true);
    try {
      const payload = {
        playerId: player?.id,
        subscriptionId: selectedPackage.value,
      };
      const res = await PaidPlayerPackageChange(payload);
      if (res) {
        toast.success("Player package changed successfully");
        setPackageModal(false);
        navigate("/admin/all-players", { replace: true });
      }
    } catch (error) {
      console.error("Error changing package:", error);
      toast.error("Failed to change package");
    } finally {
      setChangingPackage(false);
    }
  };

  return (
    <>
      {/* <PageTitle activeMenu="About Player" motherMenu="Player" /> */}
      <div className="page-titles d-flex justify-content-between align-items-center">
        <h4 className="mb-0">About Player</h4>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item ">
            <Link to="/admin/all-players">Players</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link
              onClick={(e) => e.preventDefault()}
              to="#"
              style={{
                pointerEvents: "none",
                color: "inherit",
                color: "#6F77F8",
              }}
            >
              About Player
            </Link>
          </li>
        </ol>
      </div>
      <PlayerProfile player={player} />
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`} onClick={() => setOpen2(!open2)}>
              <div className="cpa">
                <i className="fa-solid fa-file-lines me-2" />
                Payment History
              </div>
              <div>
                <div className="tools">
                  <button
                    type="button"
                    className="btn btn-primary m-2"
                    disabled={loadingPackages}
                    onClick={(e) => {
                      e.stopPropagation();
                      openPackageModal();
                    }}
                  >
                    {loadingPackages ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Loading...
                      </>
                    ) : (
                      "Change Current Package"
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary m-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadExcel(player?.id);
                    }}
                  >
                    Download
                  </button>
                </div>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body py-3">
                  <div className="table-responsive order-list-table">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table className="table table-responsive-lg  table-condensed flip-content">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Invoice No.</th>
                            <th>Package</th>
                            <th>Paid Amount</th>
                            <th>Discount Amount</th>
                            <th>Receipt No.</th>
                            <th>Payment Date</th>
                            <th>Payment Mode</th>
                            <th>Description</th>
                            <th>Download</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentDetails?.map((item, ind) => (
                            <tr key={ind}>
                              <td>{ind + 1}</td>
                              <td>{item?.invoiceNumber}</td>
                              <td>
                                {item?.player?.subscription?.packageType?.name}
                              </td>
                              <td>{item?.amount}</td>
                              <td>{item?.discountAmount || "0"}</td>
                              <td>{item?.receiptNumber}</td>
                              <td>
                                {item?.paymentDate
                                  ? new Date(
                                    item?.paymentDate + "Z",
                                  ).toLocaleString()
                                  : ""}
                              </td>

                              <td>{item?.paymentType}</td>
                              <td>{item?.description}</td>
                              <td>
                                <i
                                  className="fa-solid fa-download"
                                  role="button"
                                  title="Download selected payment"
                                  onClick={() => {
                                    setSelectedHistory(item);
                                    setReciptModal(true);
                                  }}
                                />
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-xs"
                                  title="Cancel transaction"
                                  onClick={() => handleCancelTransaction(item)}
                                >
                                  Cancel
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
      <PlayerReciptHistoryModal
        show={reciptModal}
        onClose={() => setReciptModal(false)}
        userData={selectedHistory}
        onPaymentSuccess={() => {
          setReciptModal(false);
        }}
      />

      <Modal show={packageModal} onHide={() => setPackageModal(false)} centered>
        <Modal.Header>
          <Modal.Title>Change Current Package</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setPackageModal(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <label className="form-label">Package</label>
          <Select
            options={packageOptions}
            value={selectedPackage}
            onChange={setSelectedPackage}
            className="custom-react-select"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setPackageModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handlePackageChange}
            disabled={changingPackage}
          >
            {changingPackage ? "Saving..." : "Change"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AboutPlayer;
